import { motion } from 'motion/react';

const regions = [
  { name: 'Africa', countries: 'Kenya, Tanzania, Uganda, Rwanda, Ethiopia, Ghana, Nigeria, South Africa' },
  { name: 'Middle East', countries: 'UAE, Saudi Arabia, Qatar, Oman, Kuwait' },
  { name: 'Asia', countries: 'China, India, Thailand, Vietnam, Malaysia, Indonesia, South Korea' },
];

const stats = [
  { value: '30+', label: 'Countries Served' },
  { value: '3', label: 'Continents Connected' },
  { value: '200+', label: 'Trusted Partners' },
  { value: '24/7', label: 'Operations Support' },
];

export default function WorldReach() {
  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      {/* Background world map image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20navy%20blue%20stylized%20world%20map%20with%20glowing%20warm%20gold%20dots%20marking%20major%20port%20cities%20and%20trade%20routes%20connecting%20Africa%20Middle%20East%20and%20Asia%20elegant%20minimal%20cartographic%20design%20on%20deep%20dark%20blue%20background%20professional%20corporate%20aesthetic%20subtle%20grid%20lines%20warm%20color%20palette&width=1600&height=900&seq=bekaali-map-v2-gold&orientation=landscape&nocache=true"
          alt="Global Trade Network"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-900/90 to-primary-900/70"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-400 mb-4">
            Global Network
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 uppercase tracking-tight">
            Trade Without Borders
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            From East Africa to Asia and the Middle East — BEKAALI bridges markets, connecting suppliers and buyers across three continents.
          </p>
        </motion.div>

        {/* Region Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-16">
          {regions.map((region, index) => (
            <motion.div
              key={region.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="group bg-white/[0.03] border border-white/10 rounded-2xl p-8 md:p-10 hover:bg-white/[0.06] hover:border-accent-500/30 transition-all duration-400"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/20 text-accent-400 mb-5">
                <i className="ri-map-pin-2-line text-xl"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3 uppercase tracking-wide">
                {region.name}
              </h3>
              <p className="text-sm text-white/40 leading-relaxed">
                {region.countries}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Stats row */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8"
        >
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-accent-400 mb-2">
                {stat.value}
              </div>
              <div className="text-xs uppercase tracking-wider text-white/40">
                {stat.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}